import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

// Services
import { SharedService } from 'src/app/services/shared.service';

// Animations
import { showHidden } from './animations';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.sass'],
    animations: [
        showHidden
    ],
    standalone: false
})
export class LoaderComponent implements OnInit {

  listSubcriptions: Subscription[] = [];

  showLoader: boolean = false;

  constructor(
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.listenerShowLogin()
  }

  listenerShowLogin(): void {
    this.listSubcriptions.push(
      this._sharedService.getSubjetShowLoader().asObservable().subscribe(
        (data: boolean) => {
          this.showLoader = data;
        }
      )
    );
  }

}
